import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbsUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 4,
			fill: "currentColor",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 11C4.5 13.4853 6.51472 15 9 15H9.838C12.1635 15 13.3262 15 14.1769 14.2492C15.0275 13.4983 15.1555 12.4755 15.4114 10.43C15.4664 9.99103 15.5 9.58532 15.5 9.25C15.5 7.42157 14.8284 7 13 7H9C6.51472 7 4.5 8.51472 4.5 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.2 8.40002L6.8344 7.46925C6.38712 7.64494 6.12806 8.11393 6.21746 8.58607C6.30686 9.05822 6.71946 9.40002 7.2 9.40002V8.40002ZM11.5 4.00002H12.5C12.5 3.51527 12.1523 3.10032 11.675 3.01546C11.1978 2.93061 10.7284 3.20029 10.5613 3.65534L11.5 4.00002ZM10.5 4.00002C10.5 4.60855 10.3312 5.49064 9.84274 6.18982C9.3927 6.83399 8.62405 7.40002 7.2 7.40002V9.40002C9.27595 9.40002 10.6573 8.51606 11.4823 7.33523C12.2688 6.20941 12.5 4.8915 12.5 4.00002H10.5ZM11.5 4.00002C10.5613 3.65534 10.5614 3.65501 10.5615 3.65469C10.5616 3.6546 10.5617 3.6543 10.5617 3.65412C10.5619 3.65375 10.562 3.65344 10.5621 3.65317C10.5623 3.65263 10.5624 3.65228 10.5625 3.65212C10.5626 3.65178 10.5624 3.65219 10.562 3.65331C10.5612 3.65555 10.5592 3.66065 10.5561 3.66847C10.5499 3.68411 10.5393 3.71055 10.5239 3.74657C10.4932 3.81871 10.4439 3.92876 10.3747 4.06717C10.2359 4.3449 10.0196 4.73144 9.7155 5.15266C9.10322 6.00082 8.16808 6.94539 6.8344 7.46925L7.5656 9.33079C9.36874 8.62253 10.5836 7.3671 11.3371 6.32329C11.7159 5.79853 11.9864 5.31609 12.1637 4.96134C12.2526 4.78351 12.3187 4.63645 12.3639 4.53053C12.3865 4.47753 12.4038 4.4347 12.4162 4.40333C12.4224 4.38765 12.4274 4.37481 12.4311 4.36499C12.433 4.36008 12.4345 4.35592 12.4358 4.35253C12.4364 4.35084 12.437 4.34934 12.4375 4.34803C12.4377 4.34738 12.438 4.34678 12.4382 4.34622C12.4383 4.34595 12.4384 4.34557 12.4385 4.34543C12.4386 4.34506 12.4387 4.34471 11.5 4.00002Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgThumbsUp);
export { ForwardRef as ReactComponent };
